import React from 'react';
import ReactDOM from "react-dom/client";
//import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import { getENVData } from './constants/constantValue';
//import { registerServiceWorker } from './serviceWorkerRegistration';
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const ENV = getENVData()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// let hasRendered = false;

// const renderApp = () => {
//   // if (navigator.serviceWorker.controller?.state === "activated") {
//   //   return;
//   // }
  

//   if (hasRendered) return;
//   hasRendered = true;

//   root.render(
//     <React.StrictMode>
//       <Auth0Provider
//         cacheLocation="localstorage"
//         domain={ENV.Auth0_domain}
//         clientId={ENV.Auth0_ClientId}
//         redirectUri={window.location.origin + '/viewer/'}
//         audience={ENV.Auth0_Audience}
//         useRefreshTokens={true}
//       >
//         <App />
//       </Auth0Provider>
//     </React.StrictMode>
//   );

//   reportWebVitals(console.log)
// };

// // let refreshing = false;

// // navigator.serviceWorker.addEventListener('controllerchange', () => {
// //   // 1. Exit if we are already processing a reload
// //   if (refreshing) return; 

// //   // 2. Only reload if there was an active service worker controlling 
// //   // the page BEFORE this new one took over.
// //   if (navigator.serviceWorker.controller) {
// //     refreshing = true;
// //     window.location.reload();
// //   }
// // });

// const renderTimeout = window.setTimeout(renderApp, 20000000);

// navigator.serviceWorker.ready
//   .then(() => {
//     window.clearTimeout(renderTimeout);
//     debugger;
//     renderApp();
//   })
//   .catch(() => {
//     window.clearTimeout(renderTimeout);
//     renderApp();
//   });


//registerServiceWorker();

root.render(
  <React.StrictMode>
    <Auth0Provider
      cacheLocation="localstorage"
      domain={ENV.Auth0_domain}
      clientId={ENV.Auth0_ClientId}
      redirectUri={window.location.origin + '/viewer/'}
      audience={ENV.Auth0_Audience}
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

reportWebVitals(console.log)

serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('PWA: Content is now cached for offline use!', registration);
  },
  onUpdate: (registration) => {
    console.log('PWA: New content is available; please close tabs or refresh.', registration);
  },
  onFailed: (err) => {
    console.log('PWA: Failed.', err);
  },
});
